import { AxiosError } from 'axios';
import { useCallback, useState } from 'react';

import { RedeemedPartnerKeyInterface } from '../../../models/dashboard/settings/third-party-access.model';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useRedeemPartnerKey = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(true);
  const [redeemedKey, setRedeemedKey] = useState<RedeemedPartnerKeyInterface | null>(null);
  const [errorMessage, setErrorMessage] = useState('');

  const onRedeemPartnerKeyError = useCallback((err: AxiosError<ErrorHttpResponse>) => {
    setErrorMessage(
      err?.response?.data?.message ?? 'Something went wrong while generating your key.',
    );
  }, []);

  const onRedeemPartnerKeySuccess = useCallback(
    ({ data }: SuccessHttpResponse<RedeemedPartnerKeyInterface>) => {
      setRedeemedKey(data);
    },
    [],
  );

  const redeemPartnerKey = useCallback(
    (token: string) => {
      setErrorMessage('');
      const url: HttpConfig = {
        url: `api/v1/partner-api-keys/redeem/${encodeURIComponent(token)}`,
        method: 'get',
        // Partners open this link without a Logirate account
        skipAuth: true,
        skipLogoutRedirect: true,
      };

      request(url, onRedeemPartnerKeySuccess, setLoading, onRedeemPartnerKeyError);
    },
    [request, onRedeemPartnerKeySuccess, onRedeemPartnerKeyError],
  );

  return { redeemPartnerKey, redeemedKey, errorMessage, setLoading, loading };
};

export default useRedeemPartnerKey;
